/**
 * @generated SignedSource<<32ef1a9e4b821d0cafb3b8a1f684e090>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PassengerDocuments_slot$data = {
  readonly documents: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PassengerDocument_document">;
  }>;
  readonly passenger: {
    readonly fullName: string | null;
  } | null;
  readonly " $fragmentType": "PassengerDocuments_slot";
};
export type PassengerDocuments_slot$key = {
  readonly " $data"?: PassengerDocuments_slot$data;
  readonly " $fragmentSpreads": FragmentRefs<"PassengerDocuments_slot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PassengerDocuments_slot",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Passenger",
      "kind": "LinkedField",
      "name": "passenger",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PassengerDocument",
      "kind": "LinkedField",
      "name": "documents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PassengerDocument_document"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PassengerSlot",
  "abstractKey": null
};

(node as any).hash = "799c098f5686d5ad92f25ca28cb7c270";

export default node;
